<template>
  <div class="home-navbar">
    <div class="home-links-container1">
      <router-link
        to="/"
        class="home-link10 Navbar-Link"
        exact-active-class="active-link"
      >
        Langglas
      </router-link>

      <router-link
        to="/glaszetten"
        class="home-link10 Navbar-Link"
        exact-active-class="active-link"
      >
        Glaszetten
      </router-link>
      <router-link
        to="/glas-in-lood"
        class="home-link11 Navbar-Link"
        exact-active-class="active-link"
      >
        Glas-In-Lood
      </router-link>
      <router-link
        to="/brandschilderen"
        class="home-link12 Navbar-Link"
        exact-active-class="active-link"
      >
        Brandschilderen
      </router-link>
      <router-link
        to="/fusing"
        class="home-link13 Navbar-Link"
        exact-active-class="active-link"
      >
        Fusing
      </router-link>
      <router-link
        to="/gestraald-glas"
        class="home-link14 Navbar-Link"
        exact-active-class="active-link"
      >
        Gestraald Glas
      </router-link>
      <router-link
        to="/te-koop"
        class="home-link14 Navbar-Link"
        exact-active-class="active-link"
      >
        Te Koop
      </router-link>
      <router-link
        to="/historie"
        class="home-link14 Navbar-Link"
        exact-active-class="active-link"
      >
        Historie
      </router-link>
      <router-link
        to="/contact"
        class="home-link15 Navbar-Link"
        exact-active-class="active-link"
      >
        Contact
      </router-link>
    </div>

    <h1 class="title">Langglas</h1>

    <div
      data-role="BurgerMenu"
      class="home-burger-menu"
      @click="toggleMobileMenu"
    >
      <svg viewBox="0 0 1024 1024" class="home-icon10">
        <path
          d="M128 256h768v86h-768v-86zM128 554v-84h768v84h-768zM128 768v-86h768v86h-768z"
        ></path>
      </svg>
    </div>

    <div
      v-show="mobileMenuOpen"
      data-role="MobileMenu"
      class="home-mobile-menu"
    >
      <div class="home-container2">
        <span></span>
        <div
          data-role="CloseMobileMenu"
          class="home-close-menu"
          @click="toggleMobileMenu"
        >
          <svg viewBox="0 0 1024 1024" class="home-icon12">
            <path
              d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"
            ></path>
          </svg>
        </div>
      </div>

      <div class="home-links-container2">
        <router-link
          to="/"
          class="home-link16 Navbar-Link"
          exact-active-class="active-link"
          @click="closeMobileMenu"
        >
          Home
        </router-link>
        <router-link
          to="/glaszetten"
          class="home-link16 Navbar-Link"
          exact-active-class="active-link"
          @click="closeMobileMenu"
        >
          Glaszetten
        </router-link>
        <router-link
          to="/glas-in-lood"
          class="home-link16 Navbar-Link"
          exact-active-class="active-link"
          @click="closeMobileMenu"
        >
          Glas-In-Lood
        </router-link>
        <router-link
          to="/brandschilderen"
          class="home-link16 Navbar-Link"
          exact-active-class="active-link"
          @click="closeMobileMenu"
        >
          Brandschilderen
        </router-link>
        <router-link
          to="/fusing"
          class="home-link16 Navbar-Link"
          exact-active-class="active-link"
          @click="closeMobileMenu"
        >
          Fusing
        </router-link>
        <router-link
          to="/gestraald-glas"
          class="home-link16 Navbar-Link"
          exact-active-class="active-link"
          @click="closeMobileMenu"
        >
          Gestraald Glas
        </router-link>
        <router-link
          to="/te-koop"
          class="home-link16 Navbar-Link"
          exact-active-class="active-link"
          @click="closeMobileMenu"
        >
          Te Koop
        </router-link>
        <router-link
          to="/historie"
          class="home-link16 Navbar-Link"
          exact-active-class="active-link"
          @click="closeMobileMenu"
        >
          Historie
        </router-link>
        <router-link
          to="/contact"
          class="home-link16 Navbar-Link"
          exact-active-class="active-link"
          @click="closeMobileMenu"
        >
          Contact
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      mobileMenuOpen: false,
    };
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      document.body.style.overflow = this.mobileMenuOpen ? "hidden" : "";
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
      document.body.style.overflow = "";
    },
  },
  beforeDestroy() {
    document.body.style.overflow = "";
  },
};
</script>

<style scoped>
.title {
  display: none;
}
.active-link {
  font-weight: bold;
  background-color: rgba(122, 123, 124, 0.7);
  padding: 8px 16px;
  border-radius: 20px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease;
}

.Navbar-Link {
  text-decoration: none;
  padding: 8px 10px;
  border-radius: 20px;
  transition: background-color 0.3s ease;
  white-space: nowrap;
}

.Navbar-Link:not(.active-link):hover {
  background-color: rgba(224, 224, 224, 0.6);
  padding: 8px 10px;
  border-radius: 20px;
  line-height: 1;
  display: inline-flex;
  transition: background-color 0.3s ease;
}
.home-icon10 {
  width: 36px;
  height: 36px;
}

.home-close-menu {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  padding-top: 15px;
  padding-right: 5px;
}

.home-heading2 {
  text-align: center;
}

.home-container2 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-doubleunit);
  flex-direction: row;
  justify-content: space-between;
}

.home-navbar {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  max-width: auto;
  align-items: center;
  padding-top: var(--dl-space-space-tripleunit);
  padding-left: var(--dl-space-space-tripleunit);
  padding-right: var(--dl-space-space-tripleunit);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-tripleunit);
  justify-content: space-between;
}

.home-links-container1 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
  box-sizing: border-box;
}

.home-links-container2 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.home-link10,
.home-link11,
.home-link12,
.home-link13,
.home-link14,
.home-link15 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
  width: 100%;
}

.home-link16,
.home-link17,
.home-link18 {
  margin-bottom: var(--dl-space-space-unit);
}

.home-burger-menu {
  display: none;
  align-items: flex-start;
  flex-direction: column;
  cursor: pointer;
}

.home-mobile-menu {
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100vh;
  display: none;
  padding: var(--dl-space-space-tripleunit);
  position: absolute;
  align-items: flex-start;
  flex-direction: column;
  background-color: #f2f2f2;
}

.home-icon12 {
  width: 24px;
  height: 24px;
}

@media (max-width: 1510px) {
  .home-links-container1 {
    display: none;
  }

  .home-burger-menu {
    display: flex;
  }

  .title {
    display: flex;
  }

  .home-mobile-menu {
    display: flex;
  }
}
</style>
